export const SITE_NAME = 'ЛабАктив'
export const SITE_LOCALE = 'ru_RU'
export const DEFAULT_TITLE = 'ЛабАктив'
export const DEFAULT_DESCRIPTION =
  'ЛабАктив - B2B-платформа для поиска и закупки оборудования, материалов и расходников у поставщиков.'
export const DEFAULT_OG_IMAGE = '/hero-supply.svg'
const DEFAULT_DEV_SITE_URL = 'http://localhost:5173'

function normalizeUrl(url: string): string {
  return url.replace(/\/+$/, '')
}

export function getSiteUrl(): string {
  const envUrl = import.meta.env['VITE_SITE_URL'] as string | undefined

  if (envUrl && envUrl.trim() !== '') {
    return normalizeUrl(envUrl)
  }

  if (typeof window !== 'undefined' && window.location.origin) {
    return normalizeUrl(window.location.origin)
  }

  return DEFAULT_DEV_SITE_URL
}

export function toAbsoluteUrl(pathOrUrl: string | undefined | null): string {
  const fallbackPath = DEFAULT_OG_IMAGE
  const source = pathOrUrl && pathOrUrl.trim() !== '' ? pathOrUrl : fallbackPath

  if (/^https?:\/\//i.test(source)) {
    return source
  }

  const normalizedPath = source.startsWith('/') ? source : `/${source}`
  return `${getSiteUrl()}${normalizedPath}`
}
